var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.335 20c-5.523 0-10-4.477-10-10 0-4.478 2.943-8.268 7-9.542v2.124a8.003 8.003 0 003 15.418 8.003 8.003 0 007.418-5h2.124c-1.274 4.057-5.064 7-9.542 7zm9.95-9H9.335V.05c.329-.033.663-.05 1-.05 5.523 0 10 4.477 10 10 0 .337-.017.671-.05 1zm-8.95-8.938V9h6.938a8.004 8.004 0 00-6.938-6.938z",
    fill: "#12C1F9"
  })));
}
export default SvgReportsActive;